const $moreBtn = document.querySelector("#show-more-btn-js");
const $itemsBlock = document.querySelector("#list-articles-js");

const offset = 21;
const category = Number($moreBtn.dataset.category);
const templateItems = _.template(document.querySelector("#items-template").innerHTML);
const dataPost = {
  offset,
  categoryId: category,
};

$moreBtn.addEventListener("click", function (e) {
  e.preventDefault();
  const $this = e.target;

  if ($this.disabled !== true) {
    $this.disabled = true;
    const topOffsetBefore = window.pageYOffset;

    jxAction("get_post", dataPost, function (data) {
      const countOfData = data.posts.length;

      $itemsBlock.insertAdjacentHTML("beforeend", templateItems({ items: data.posts }));
      window.scrollTo(0, topOffsetBefore);

      if (countOfData < 10) {
        $this.style.display = "none";
      } else {
        $this.disabled = false;
        dataPost.offset += 10;
      }
    });
  }
});
